<div>
    <div>
        <ngb-tabset (tabChange)="onTabChange($event)">
            <ngb-tab title="{{ 'energy-graph.energy' | translate }}" id="energy"></ngb-tab>
            <ngb-tab title="{{ 'energy-graph.co2' | translate }}" id="co2"></ngb-tab>
        </ngb-tabset>
        <canvas #chart class="mt-3" id="energyChart"></canvas>
    </div>
</div>